import { render, staticRenderFns } from "./CampaignEditor.vue?vue&type=template&id=82fcff92&scoped=true"
import script from "./CampaignEditor.vue?vue&type=script&lang=js"
export * from "./CampaignEditor.vue?vue&type=script&lang=js"
import style0 from "./CampaignEditor.vue?vue&type=style&index=0&id=82fcff92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fcff92",
  null
  
)

export default component.exports